import axios from 'axios';
import {
  PLUGIN_LOAD_ALL_EXTENSION_BEGIN,
  PLUGIN_LOAD_ALL_EXTENSION_SUCCESS,
  PLUGIN_LOAD_ALL_EXTENSION_FAILURE,
  PLUGIN_LOAD_ALL_EXTENSION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadAllExtension(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_ALL_EXTENSION_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/extensions/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_ALL_EXTENSION_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: PLUGIN_LOAD_ALL_EXTENSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAllExtensionError() {
  return {
    type: PLUGIN_LOAD_ALL_EXTENSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_ALL_EXTENSION_BEGIN:
      return {
        ...state,
        loadAllExtensionPending: true,
        loadAllExtensionError: null,
      };

    case PLUGIN_LOAD_ALL_EXTENSION_SUCCESS:
      return {
        ...state,
        loadAllExtensionPending: false,
        loadAllExtensionError: null,
        extensions: action.data,
        pluginDetail: null,
      };

    case PLUGIN_LOAD_ALL_EXTENSION_FAILURE:
      return {
        ...state,
        loadAllExtensionPending: false,
        loadAllExtensionError: action.data.error,
      };

    case PLUGIN_LOAD_ALL_EXTENSION_DISMISS_ERROR:
      return {
        ...state,
        loadAllExtensionError: null,
      };

    default:
      return state;
  }
}
